/**
 * This module re-exports Dimensionsless from Unit and adds some extra units
 */
import { Unit } from "uom";
export var One = Unit.One;
export var Percent = Unit.divideNumber("Percent", 100.0, Unit.One);
export var PPM = Unit.divideNumber("PPM", 1000000.0, Unit.One);
//# sourceMappingURL=dimensionless.js.map